import React from 'react'
import { CustomModal } from '../CustomModal/CustomModal'
import { t } from 'i18next'
import { ContractDetailList } from './ContractDetailList'
import { CustomTable } from '../CustomTable/CustomTable';
import { EmptyStateOne } from '../Empty/EmptyStateOne';
import { CustomTooltip } from '../CustomTooltip/CustomTooltip';

const TableHeaderWithTooltip = ({ label, tooltipText, id,iconClass }) => (
    <>
        <CustomTooltip placement="top" target={id} text={tooltipText} />
        <span className="d-inline-flex align-items-center justify-content-center gap-1">
            {label}
            <i
                id={id}
                className={iconClass}
                style={{ color: 'var(--gray-500)', cursor: 'pointer' }}
            />
        </span>
    </>
);

export const ContractsDetailModal = ({ resource = '', contracts = [], showModal, setShowModal }) => {

    const isAssignedToResource = contracts.some(contract => contract.is_assigned_to_resource);
    
    const tableHeaders = [
        { key: t('CODE') },
        { key: t('DESCRIPTION') },
        { key: t('OPENING') },
        {
            key: (
                <TableHeaderWithTooltip
                    label={t('DATE_SINCE')}
                    tooltipText={ isAssignedToResource ? t('CONTRACT_DATE_RESOURCE_ASSIGNMENT_TOOLTIP') : t('CONTRACT_DATE_VALIDITY_TOOLTIP')}
                    id="contractsDateSinceHeaderTooltip"
                    iconClass="fa-solid gray-900-color fa-circle-info"
                />
            ),
        },
        {
            key: (
                <TableHeaderWithTooltip
                    label={t('DATE_UNTIL')}
                    tooltipText={ isAssignedToResource ? t('CONTRACT_DATE_RESOURCE_ASSIGNMENT_TOOLTIP') : t('CONTRACT_DATE_VALIDITY_TOOLTIP')}
                    id="contractsDateUntilHeaderTooltip"
                    iconClass="fa-solid gray-900-color fa-circle-info"
                />
            ),
        },
        { key: t('STATE') },
    ]

    const noContractsText = {
        EMP: 'EMP_HAS_NOT_CONTRACTS_ASSIGNED',
        VEH: 'VEH_HAS_NOT_CONTRACTS_ASSIGNED',
    }

    return (
        <CustomModal
            showModal={showModal}
            setShowModal={setShowModal}
            centered
            title={t("CONTRACTS_DETAILS")}
            backgroundColor='var(--gray-50)'
        >
            <div>

                {
                    contracts.length > 0 ? (
                        <div className='table-responsive'>

                            <CustomTable headers={tableHeaders} id={'contractsDetailsTable'}>

                                {contracts.map((contract) =>
                                    <ContractDetailList
                                        key={contract.idCONTRATO}
                                        contract={contract}
                                    />
                                )}

                            </CustomTable>

                        </div>
                    )
                        :
                        <EmptyStateOne
                            message={
                                t(`${noContractsText[resource]}`)
                            }
                        />
                }

            </div>
        </CustomModal>
    )
}
